import useTimer from '../../hooks/useTimer';
import TimerDisplay from './TimerDisplay';

function Timer({ initialTime, direction = 'down', style, onComplete }) {
  const { time } = useTimer({
    initialTime,
    direction,
    onComplete,
  });

  return (
    <div>
      <TimerDisplay time={time} style={style} />
    </div>
  );
}

export default Timer;
